/** * 防沉迷弹窗 */

<template>
  <div :class="[$style.wrap, fullScreen && $style.fullScreen]">
    <header>
      <span>防沉迷提示</span>
      <img :src="fanhuiIcon" alt :class="$style.fanhui" v-if="cBranch.close" @click="visitorMode" />
    </header>
    <main>
      <div :class="$style.antiIndulged">
        <div :class="$style.content">
          <p v-html="cBranch['text']"></p>
          <div :class="$style.bindFm" v-if="cBranch.bind">
            <img :src="zhanghaoIcon" alt="">
            <input type="text" v-model.trim="form['id_card_name']" placeholder="请输入姓名" />
          </div>
          <div :class="$style.bindFm" v-if="cBranch.bind">
             <img :src="idCardIcon" alt="">
            <input type="text" v-model.trim="form['id_card_num']" placeholder="请输入身份证号" />
          </div>
        </div>
        <div :class="`${!cBranch.bind && $style.fixedB}`">
          <div :class="$style.btnGp">
            <button v-show="(antiInduledHintShow || item.event != 'contact')" v-for="(item, index) in cBranch.btnGp" :key="index" @click="handleBtnClick(item)" :class="item.type === 'primary' ? $style.btnP : ''">{{ item.text }}</button>
          </div>
          <div :class="$style.antiInduledHint" v-if="antiInduledHintShow">点击<a @click="contact">联系客服</a>，若无法联系客服请尝试<a class="copy-btn" data-clipboard-target="#copy">复制链接</a>前往浏览器打开</div>
        </div>
        <input type="text" :class="$style.antiInduledCp" id="copy" readonly :value="customer" />
      </div>
    </main>
  </div>
</template>

<script>
import { cdnLink } from '@/config';
import { GetAge } from '@/libs/utils';
import _ from 'lodash';
import Clipboard from 'clipboard';
import { mapState, mapActions } from 'vuex';
import { enterAntiPort } from '@/api/user';
import isFullScreen from '@/libs/business/fullScreen';
/* 
  防沉迷分支 产品文档：蓝湖 -> 防沉迷v2.0
  branch -> 0.防沉迷(开)实名认证(开) 1.防沉迷(关)实名认证(开)
 */
const login_branch = {
  // 防沉迷(开)实名认证(开)
  0: {
    // 用户未绑定身份证，游戏时长超过1h 15天内没有登陆过
    0: {
      text: '根据国家政策，需要您绑定身份证才能正常进入游戏，请完成身份认证工作',
      bind: true,
      btnGp: [
        {
          text: '联系客服',
          event: 'contact'
        },
        {
          text: '实名认证',
          event: 'submit',
          type: 'primary'
        }
      ]
    },
    1: {
      text: '根据国家政策，需要您绑定身份证才能正常进入游戏，请完成身份认证工作',
      bind: true,
      btnGp: [
        {
          text: '联系客服',
          event: 'contact'
        },
        {
          text: '实名认证',
          event: 'submit',
          type: 'primary'
        }
      ]
    },
    3: {
      text: `
        由于您将绑定的身份证号未满18周岁，将受到防沉迷保护限制，无法登录游戏。
      `,
      btnGp: [
        {
          text: '继续绑定',
          event: 'confirmBind'
        },
        {
          text: '重新绑定',
          event: 'rebind',
          type: 'primary'
        }
      ]
    },
    // 用户绑定身份证，未满18周岁
    4: {
      text: `
        由于您将绑定的身份证号未满18周岁，将受到防沉迷保护限制，无法登录游戏，如有疑问，请点击联系客服处理。
      `,
      btnGp: [
        {
          text: '联系客服',
          event: 'contact',
          type: 'primary'
        },
        {
          text: '确认',
          event: 'quitGame'
        }
      ]
    },
    // 用户绑定的身份证未满18周岁，游戏达到规定时间
    5: {
      text: '由于您所绑定的身份证号未满18周岁，当前游戏时间未在法律规定时间内，如有疑问请尽快联系客服（游戏时间：每周五、周六、周日和法定节假日，每日20时至21时提供1小时网络游戏服务），目前已超出健康游戏体验时间，将强制游戏下线，如有疑问请联系客服。',
      btnGp: [
        {
          text: '联系客服',
          event: 'contact',
          type: 'primary'
        },
        {
          text: '退出游戏',
          event: 'quitGame'
        }
      ]
    }
  },
  // 防沉迷(关)实名认证(开)
  1: {
    0: {
      text: '根据国家政策，需要您绑定身份证才能正常进入游戏，请完成身份认证工作',
      bind: true,
      close: true, // 是否有右上角关闭
      btnGp: [
        {
          text: '下次再说',
          event: 'visitorMode'
        },
        {
          text: '确认',
          event: 'submit',
          type: 'primary'
        }
      ]
    },
    2: {
      text: '您所绑定的身份证号未满18周岁，将会受到防沉迷限制，限制每日的累计游戏时长与充值。',
      btnGp: [
        {
          text: '联系客服',
          event: 'contact',
          type: 'primary'
        },
        {
          text: '确认',
          event: 'confirm'
        }
      ]
    }
  }
};

const payment_branch = {
  0: {
    text: '您所绑定的身份证号未满18周岁，将会受到防沉迷限制，是否还要继续绑定？',
    btnGp: [
      {
        text: '继续绑定',
        event: 'confirmBind'
      },
      {
        text: '重新绑定',
        event: 'rebind',
        type: 'primary'
      }
    ]
  },
  1: {
    text: '您所绑定的身份证号未满18周岁，将会受到防沉迷限制，如有疑问请尽快联系客服',
    btnGp: [
      {
        text: '联系客服',
        event: 'contact',
        type: 'primary'
      },
      {
        text: '确认',
        event: 'confirm'
      }
    ]
  },
  4: {
    text: '根据国家新闻出版署《关于防止未成年人沉迷网络游戏的通知》，游客有60分钟体验时间，在此模式下不能充值和付费消费。',
    bind: true,
    btnGp: [
      {
        text: '取消',
        event: 'cancel'
      },
      {
        text: '实名认证',
        event: 'submit',
        type: 'primary'
      }
    ]
  },
  5: {
    text: '您目前为未成年人账号，已被纳入防沉迷系统，根据国家新闻出版署《关于防止未成年人沉迷网络游戏的通知》，本游戏不为未满8周岁的用户提供游戏充值服务。',
    btnGp: [
      {
        text: '联系客服',
        event: 'contact',
        type: 'primary'
      },
      {
        text: '确认',
        event: 'confirm'
      }
    ]
  },
  6: {
    text: '您目前为未成年人账号，已被纳入防沉迷系统，根据国家新闻出版署《关于防止未成年人沉迷网络游戏的通知》，游戏中8周岁以上未满16周岁的用户，单次充值金额不得超过50元人民币，每月充值金额累计不得超过200元人民币。',
    btnGp: [
      {
        text: '联系客服',
        event: 'contact',
        type: 'primary'
      },
      {
        text: '确认',
        event: 'confirm'
      }
    ]
  },
  7: {
    text: '您目前为未成年人账号，已被纳入防沉迷系统，根据国家新闻出版署《关于防止未成年人沉迷网络游戏的通知》，游戏中16周岁以上未满18周岁的用户，单次充值金额不得超过100元人民币，每月充值金额累计不得超过400元人民币。',
    btnGp: [
      {
        text: '联系客服',
        event: 'contact',
        type: 'primary'
      },
      {
        text: '确认',
        event: 'confirm'
      }
    ]
  }
};

export default {
  name: '',
  props: {
    // login 登录弹出 payment 支付弹出
    branch: {
      required: true
    },
    type: {
      required: true
    },
    isH5: {
      default: false
    },
    title: {
      default: '防沉迷提示'
    }
  },
  data() {
    return {
      fullScreen: '',
      cdnLink,
      form: {
        id_card_num: '',
        id_card_name: ''
      },
      lastBranch: null, // 记录重新绑定操作返回的上一个分支
      customer: '',
      fanhuiIcon: `${this.$cdnLink}/wanXin/orangeTheme/fanhui.png`,
      zhanghaoIcon: `${this.$cdnLink}/wanXin/orangeTheme/zhanghao.png`,
      idCardIcon: `${this.$cdnLink}/wanXin/orangeTheme/idcard.png`,
      antiInduledHintShow: true
    };
  },
  created() {
    this.fullScreen = isFullScreen();
  },
  async mounted() {
    this.copyInit();
    this.customer = await this.getCustomerLink();
    this.buryPoint();
    this.hiddenHint()
  },
  computed: {
    ...mapState({
      userState: state => state.user
    }),
    cBranch: {
      get() {
        let branch = this.branch === 'login' ? login_branch[this.type[0]][this.type[1]] : payment_branch[this.type];
        return branch;
      },
      set() {
        console.log(332);
      }
    }
  },
  methods: {
    ...mapActions({
      openCustomer: 'global/openCustomer',
      getCustomerLink: 'global/getCustomerLink'
    }),
    hiddenHint() {
      const appkey = localStorage.getItem('appkey');
      // 200014180
      const whiteList = ["200014180", "200014055", "200012109", "200014482", "200014495", "200014595", "200014727","200031775"]
      if (whiteList.includes(appkey) || this.userState.verify_customer_state == 1) {
        this.antiInduledHintShow = false;
      }
      const tipsList = ["200031775"]
      if (tipsList.includes(appkey)) {
        this.cBranch['text'] = '根据国家新闻出版署《关于防止未成年人沉迷网络游戏的通知※关于进一步严格管理 切实防止未成年人沉迷网络游戏的通知》要求,需要您绑定身份证才能正常进入游戏，请完成身份认证工作';
      }
    },
    buryPoint() {
      let branch = this.branch === 'login' ? login_branch[this.type[0]][this.type[1]] : payment_branch[this.type];
      if (branch && branch.bind) {
        enterAntiPort({
          appkey: this.userState.appkey,
          user_id: this.userState.user_id
        });
      }
    },
    copyInit() {
      this.copy = new Clipboard('.copy-btn');
      this.copy.on('success', e => {
        console.log(337);
        this.$toast('复制成功');
      });
    },
    handleBtnClick(item) {
      if (this[item.event]) {
        this[item.event]();
      }
    },
    // 提交实名认证
    submit() {
      const age = GetAge(this.form.id_card_num);
      if (age < 18) {
        this.lastBranch = _.cloneDeep(this.type);
        // 未实名认证到提示界面
        this.$emit('changeData', 'antiInduledType', this.branch === 'login' ? [0, 3] : 0);
      } else {
        this.$emit('submit', this.form);
      }
    },
    confirmBind() {
      // 传1表示绑定的用户为未成年用户
      this.$emit('submit', this.form, 1);
    },
    rebind() {
      // 重新绑定切回上次绑定页
      this.lastBranch = this.lastBranch || [0, 1];
      this.$emit('changeData', 'antiInduledType', this.lastBranch);
      this.lastBranch = null;
    },
    // 关闭认证窗口
    // [1, 2] 已实名未成年用户
    confirm() {
      this.$emit('confirm', this.branch === 'login' ? this.type.join(',') : this.type);
    },
    // 联系客服
    contact() {
      this.openCustomer();
    },
    quitGame() {
      this.$emit('quitGame');
    },
    // 游客模式
    visitorMode() {
      // 进入游客模式确认页的type [0, 1] [1, 0]
      // 确认进入游客模式的type [0, 2] 游客模式确认页相关逻辑已经不再用，留在需要时使用
      const toConfirmList = ['0,1', '1,0']
      const type = this.type.join(',')
      if (toConfirmList.includes(type) && this.remainTime) {
        this.lastBranch = _.cloneDeep(this.type)
        this.$emit('changeData', 'antiInduledType', [0, 2])
      } else {
        this.$emit('visitorModeLogin')
      }
    },
    cancel() {
      this.$emit('cancel')
    }
  }
};
</script>

<style lang="scss" module>
@import '../../assets/css/common.scss';

.wrap {
  @include common-window();
  > header {
    position: relative;
    > span {
      font-weight: 600;
      font-style: italic;
    }
    .fanhui {
      position: absolute;
      top: 0.35rem;
      right: 0.35rem;
      width: 0.34rem;
      height: 0.25rem;
    }
  }
  > main {
    padding: 0.35rem 0.2rem;
    overflow-y: auto;
    .antiIndulged {
      .content {
        min-height: 100px;
        > p {
          padding: 0 0 0 0.15rem;
          font-size: 0.24rem;
          color: #FB5D56;
        }
      }
      .bindFm {
        width: 4.44rem;
        height: 0.68rem;
        background: #f7f7f7;
        border-radius: 0.1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0.15rem auto;
        > img {
          margin-left: .06rem;
          width: .26rem;
        }
        > input {
          width: 3.8rem;
          margin: 0 0.1rem;
          background: none;
          border: none;
        }
      }
      .btnGp {
        display: flex;
        justify-content: center;
        margin-top: 0.15rem;
        > button {
          @include common-button();
          width: 2rem;
          height: 0.58rem;
          margin: 0 0.2rem;
        }
      }
      .antiInduledHint {
        color: #888888;
        font-size: 0.2rem;
        line-height: 0.26rem;
        text-align: center;
        margin-top: 0.1rem;
        > button {
          background: none;
          border: none;
          outline: none;
          color: $primary-color;
          font-size: 0.2rem;
        }
        > a {
          color: $primary-color;
        }
      }
      .antiInduledCp {
        position: absolute;
        left: 0;
        top: -1000rem;
        z-index: -1;
      }
    }
  }
  // 全屏版本
  &.fullScreen {
    @include full-screen-window();
    > header {
      position: relative;
      > span {
        font-weight: 600;
        font-style: italic;
      }
      .fanhui {
        position: absolute;
        top: 17px;
        right: 17px;
        width: 17px;
        height: 12px;
      }
    }
    > main {
      padding: 17px 5px;
      overflow-y: auto;
      .antiIndulged {
        .content {
          min-height: 100px;
        }
        p {
          padding: 0 0 0 7px;
          font-size: 12px;
        }
        .bindFm {
          width: 222px;
          height: 34px;
          background: #f7f7f7;
          border-radius: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 7px auto;
          > img {
            width: 13px;
            margin-left: 3px;
          }
          > input {
            width: 190px;
            margin: 0 5px;
            background: none;
            border: none;
          }
        }
        .btnGp {
          display: flex;
          justify-content: center;
          margin-top: 7px;
          > button {
            @include full-screen-button();
            width: 100px;
            height: 29px;
            margin: 0 10px;
          }
        }
        .antiInduledHint {
          color: #888888;
          font-size: 10px;
          line-height: 13px;
          text-align: center;
          margin-top: 10px;
          > a {
            background: none;
            border: none;
            outline: none;
            color: $primary-color;
            font-size: 10px;
          }
          > span {
            color: $primary-color;
          }
        }
        .antiInduledCp {
          position: absolute;
          left: 0;
          top: -1000px;
          z-index: -1;
        }
      }
    }
  }
}
</style>
,

